module.exports = __webpack_public_path__ + "static/media/icon-error.008f5f9d.svg";